import axios from 'axios'
import { message } from 'ant-design-vue'
import Vue from 'vue'
import { A_ACCESS_TOKEN, A_TENANT_ID, ACCESS_TOKEN, TENANT_ID, REGISTER_TENANT_ID } from '@/store/mutation-types'
import { getUrlParams } from '@/utils/util'

const getGlobalUrl = async function getGlobalUrl (url) {
  if (!window.urlConfig) {
    const res = await axios.get('/globalConfigFriendly.json')
    const urlConfig = res.data
    window.urlConfig = urlConfig
  }
  const urlConfig = window.urlConfig
  const query = getUrlParams()
  Vue.ls.set(REGISTER_TENANT_ID, query?.tenantId)
  const urls = {
    // 用户中心
    userCenterUrl: process.env.NODE_ENV === 'production' ? urlConfig.requests.userCenterUrl : urlConfig.requests.userCenterUrl,
    // 平台中心
    platformUrl: process.env.NODE_ENV === 'production' ? urlConfig.requests.platformUrl : urlConfig.requests.platformUrl,
    // 用户接口
    medicalUserUrl: process.env.NODE_ENV === 'production' ? urlConfig.requests.medicalUrl : urlConfig.requests.medicalUrl,
    // 中间件
    middlewareUrl: process.env.NODE_ENV === 'production' ? urlConfig.requests.middlewareUrl : urlConfig.requests.middlewareUrl,
    // 文件上传
    fileUrl: process.env.NODE_ENV === 'production' ? urlConfig.requests.fileUrl : urlConfig.requests.fileUrl,
    // CA接口
    CAUrl: process.env.NODE_ENV === 'production' ? urlConfig.requests.CAUrl : urlConfig.requests.CAUrl
  }
  return urls[url]
}

async function setWindowGlobalUrl () {
  console.log('setWindowGlobalUrl')
  if (!window.urlConfig) {
    const res = await axios.get('/globalConfigFriendly.json')
    const urlConfig = res.data
    window.urlConfig = urlConfig
  }
  const urlConfig = window.urlConfig
  const query = getUrlParams()
  Vue.ls.set(REGISTER_TENANT_ID, query.tenantId)
}

// tType 认证信息 user 用户中心认证 platform 平台认证
function newRequest (url, tType) {
  const service = axios.create({
    // baseURL: url,
    timeout: 60000
  })

  service.interceptors.request.use(async config => {
    // 设置基本路径
    const baseUrl = await getGlobalUrl(url)
    config.baseURL = baseUrl
    const tokens = {
      user: Vue.ls.get(A_ACCESS_TOKEN),
      platform: Vue.ls.get(ACCESS_TOKEN)
    }
    const tId = {
      user: Vue.ls.get(A_TENANT_ID),
      platform: Vue.ls.get(TENANT_ID)
    }
    if (tokens[tType]) {
      // 配置token
      config.headers.Authorization = `Bearer ${tokens[tType]}`
    }
    if (tId[tType]) {
      // 配置 Abp.TenantId
      config.headers['Abp.TenantId'] = tId[tType]// 平台或用户中心租户
    }
    return config
  }, err => {
    console.error(err)
    return Promise.reject(err)
  })

  service.interceptors.response.use(res => {
    return res.data
  }, err => {
    const data = err.response.data
    if (err.response.status === 403) {
      message.error('未有此操作权限')
    }
    if (err.response.status === 401 && !(data.result && data.result.isLogin)) {
      message.error('登录认证失效，请重新登录')
      location.href = location.origin
    }
    return data
  })
  return service
}

const UserCenterService = newRequest('userCenterUrl', 'user')
const bUserService = newRequest('platformUrl', 'platform')
const medicalUserService = newRequest('medicalUserUrl', 'user')
const middlewareService = newRequest('middlewareUrl', 'platform')
const middlewareNoTokenService = newRequest('middlewareUrl', 'noToken')
const FileService = newRequest('fileUrl', 'platform')
const CAService = newRequest('CAUrl', 'noToken')

export {
  getGlobalUrl,
  setWindowGlobalUrl,
  UserCenterService,
  bUserService,
  medicalUserService,
  middlewareService,
  middlewareNoTokenService,
  FileService,
  CAService,
}
